var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lib-radio-select" },
    _vm._l(_vm.options, function (option, index) {
      return _c("div", { staticClass: "radio" }, [
        _c("input", {
          staticClass: "input-radio",
          attrs: {
            type: "radio",
            id: "option_" + _vm.name + "_" + index,
            name: _vm.name,
          },
          domProps: {
            checked: _vm.options.indexOf(option) === _vm.value,
            value: option.description,
          },
          on: {
            input: function ($event) {
              return _vm.select(option)
            },
          },
        }),
        _c(
          "label",
          {
            staticClass: "radio-label",
            attrs: { for: "option_" + _vm.name + "_" + index },
          },
          [_vm._v(_vm._s(option.description))]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }